import React from 'react'
import { ethers } from 'ethers'
import { chainId } from './address'

// Store Rabby provider for contract interactions
let rabbyProvider = null

const getRabbyProvider = () => {
  if (rabbyProvider) return rabbyProvider
  if (window.ethereum?.isRabby) return window.ethereum
  return null
}

export const connectWallet = async () => {
  // Try EIP-6963 first to get Rabby when multiple wallets installed
  const getRabbyFromEIP6963 = () => {
    return new Promise((resolve) => {
      const handler = (event) => {
        const { info, provider } = event.detail
        if (info.rdns === 'io.rabby') {
          window.removeEventListener('eip6963:announceProvider', handler)
          resolve(provider)
        }
      }
      window.addEventListener('eip6963:announceProvider', handler)
      window.dispatchEvent(new Event('eip6963:requestProvider'))
      setTimeout(() => {
        window.removeEventListener('eip6963:announceProvider', handler)
        resolve(null)
      }, 1000)
    })
  }

  let provider = getRabbyProvider()
  if (!provider) {
    provider = await getRabbyFromEIP6963()
  }
  if (!provider && window.ethereum?.isRabby) {
    provider = window.ethereum
  }

  if (provider) {
    try {
      rabbyProvider = provider
      const chain = await provider.request({ method: 'eth_chainId' })
      if (parseInt(chain, 16) == chainId) {
        const addressArray = await provider.request({
          method: 'eth_requestAccounts',
        })
        if (addressArray.length > 0) {
          return {
            address: addressArray[0],
            status: "👆🏽 You can play now.",
          }
        } else {
          return {
            address: "",
            status: "😥 Connect your wallet account to the site.",
          }
        }
      } else {
        await provider.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: chainId }],
        })
        return {
          address: "",
          status: "😥 Connect your wallet account to the site.",
        }
      }
    } catch (err) {
      return {
        address: "",
        status: "😥 " + err.message,
      }
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {' '}
            🐰{' '}
            You must install Rabby Wallet in your browser.
            (https://rabby.io)
          </p>
        </span>
      ),
    }
  }
}

export const getCurrentWalletConnected = async () => {
  const provider = getRabbyProvider()
  if (provider) {
    try {
      const addressArray = await provider.request({
        method: "eth_accounts",
      })
      const chain = await provider.request({
        method: "eth_chainId",
      })
      if (addressArray.length > 0 && parseInt(chain, 16) == chainId) {
        return {
          address: addressArray[0],
          status: "👆🏽 You can play now.",
        }
      } else {
        return {
          address: "",
          status: "🐰 Connect to Rabby Wallet and choose the correct chain.",
        }
      }
    } catch (err) {
      return {
        address: "",
        status: "😥 " + err.message,
      }
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {' '}
            🐰{' '}
            You must install Rabby Wallet in your browser.
            (https://rabby.io)
          </p>
        </span>
      ),
    }
  }
}

export const getContractWithSigner = (contractAddress, contractABI) => {
  const provider = getRabbyProvider()
  const ethProvider = provider || window.ethereum
  let web3Provider = new ethers.providers.Web3Provider(ethProvider)
  let signer = web3Provider.getSigner()

  let contract = new ethers.Contract(
    contractAddress,
    contractABI,
    signer
  )

  return contract
}

export const getContractWithoutSigner = (contractAddress, contractABI) => {
  const provider = getRabbyProvider()
  const ethProvider = provider || window.ethereum
  let web3Provider = new ethers.providers.Web3Provider(ethProvider)

  let contract = new ethers.Contract(
    contractAddress,
    contractABI,
    web3Provider
  )

  return contract
}

export const getContract = (contractAddress, contractABI) => {
  const provider = getRabbyProvider()
  const ethProvider = provider || window.ethereum
  let web3Provider = new ethers.providers.Web3Provider(ethProvider)
  let signer = web3Provider.getSigner()

  let contract = new ethers.Contract(
    contractAddress,
    contractABI,
    signer
  )
  return contract
}
